import { Injectable, OnDestroy } from '@angular/core'
import { JobsKey } from '@helios/panels/jobs'
import {
  JobsPayload,
  RootState,
  focusPanelAction,
  setFocusedJobs,
  showJobsAction,
} from '@helios/state-management'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

/**
 * Listen to redux for focused files and trigger the Jobs panel Redux action to focus the appropriate panel on the appropriate item.
 * Depending on the details of the particular jobId, this determines what item needs to be focused on and sets that item as focused in Redux.
 */
@Injectable()
export class JobsEffects implements OnDestroy {
  private readonly _destroyed$ = new Subject<void>()

  constructor(
    private readonly store: Store<RootState>,
    private readonly actions$: Actions,
  ) {
    this.actions$
      .pipe(takeUntil(this._destroyed$), ofType(showJobsAction))
      .subscribe(action => this.onJobsFocused(action['payload']))
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  private onJobsFocused(payload: JobsPayload) {
    // focusing panel first and then panel to start listening state events
    this.store.dispatch(setFocusedJobs(payload))
    setTimeout(() => this.focusPanel(JobsKey), 0)
  }

  private focusPanel(panelKey: string) {
    this.store.dispatch(focusPanelAction(panelKey))
  }
}
